import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import ErrorPlugin from "./plugins//error";

// 圖片放大
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

import './assets/css/main.scss'
import './assets/css/sm.scss'
import './assets/css/xs.scss'

Vue.use(VueI18n);
Vue.use(ElementUI);
Vue.use(ErrorPlugin);

// 語言包（i18n）
import LangEN from '../public/lang/EN'
import LangPT from '../public/lang/PT'
import LangZHTW from '../public/lang/ZH_TW'
import LangZHCN from '../public/lang/ZH_CN'

const i18n = new VueI18n({
  locale: localStorage.getItem('lan') || 'ZH_TW',
  messages: {
    'EN': LangEN,
    'PT': LangPT,
    'ZH_CN': LangZHCN,
    'ZH_TW': LangZHTW
  }
})

locale.i18n((key, value) => i18n.t(key, value))

Vue.filter('formatProgress', function (progress) {
  return parseInt(progress.replace("%", ""));
})

Vue.filter('abcd', function (str) {
  const index = parseInt(str);
  const arr = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N'];
  return arr[index];
})


Vue.filter('capitalLetter', function (val) {
  const num = parseInt(val);
  const numberToCN = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十',
    '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九',
    '二十', '二十一', '二十二', '二十三', '二十四', '二十五', '二十六', '二十七',
    '二十八', '二十九', '三十', '三十一', '三十二', '三十三', '三十四', '三十五',
    '三十六', '三十七', '三十八', '三十九', '四十', '四十一', '四十二', '四十三', '四十四', '四十五', '四十六',
    '四十七', '四十八', '四十九', '五十', '五十一', '五十二', '五十三', '五十四', '五十五', '五十六',
    '五十七', '五十八', '五十九'
  ];
  return numberToCN[num];
})

// Vue.filter('capitalSection', function (val) {
//   const num = parseInt(val);
//   const numberToCN = ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十',
//     '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九',
//     '二十', '二十一', '二十二', '二十三', '二十四', '二十五', '二十六', '二十七',
//     '二十八', '二十九', '三十', '三十一', '三十二', '三十三', '三十四', '三十五',
//     '三十六', '三十七', '三十八', '三十九', '四十', '四十一', '四十二', '四十三', '四十四', '四十五', '四十六',
//     '四十七', '四十八', '四十九', '五十', '五十一', '五十二', '五十三', '五十四', '五十五', '五十六',
//     '五十七', '五十八', '五十九'
//   ];
//   return `第${numberToCN[num]}節`;
// })

Vue.filter('sortLetter', function (val) {
  if (val) {
    return val.split('').sort().join('');
  }
})


Vue.filter('formatDate', function (value) {

  let date = new Date(value);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
})

// Vue.config.lang = 'zh-cn'
// Vue.locale('zh-cn', zhLocale)
// Vue.locale('en', enLocale)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')